// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".serachinput[data-v-04552606] {\n  width: 300px;\n  box-sizing: border-box;\n  padding: 9px;\n  border: 1px solid #dddee1;\n  line-height: 20px;\n  font-size: 16px;\n  height: 38px;\n  color: #333;\n  position: relative;\n  border-radius: 4px;\n  box-shadow: #666 0px 0px 10px;\n}\n[data-v-04552606] .el-dialog__header {\n  border-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
